import { Component, OnInit } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { UigMediaService } from 'src/app/services/uig-media.service';
import { ViewEncapsulation } from '@angular/core';

import { Observable } from 'rxjs';

@Component({
    selector: 'app-uig-campaigns-icons',
    templateUrl: './uig-campaigns-icons.component.html',
    styleUrls: ['./uig-campaigns-icons.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigCampaignsIconsComponent implements OnInit {

  product$: Observable<Product> = this.currentProductService.getProduct();
  mediaService = this.uigMediaService;

  constructor(private currentProductService: CurrentProductService, private uigMediaService : UigMediaService) { }

  ngOnInit(): void {
  }

}
